import { useIntl } from 'react-intl';
import { AutomationLevel } from '@rossum/api-client/queues';
import {
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@rossum/ui/material';
import { boldText } from '../../../../../lib/formaterValues';

type AutomationLevelOptionsProps = {
  automationLevel: AutomationLevel;
  onChange: (value: AutomationLevel) => void;
  disabled?: boolean;
};

const confidenceLevels = [
  {
    key: 'confident',
  },
  {
    key: 'always',
  },
  {
    key: 'never',
  },
] as const;

export const AutomationLevelOptions = ({
  automationLevel,
  onChange,
  disabled,
}: AutomationLevelOptionsProps) => {
  const intl = useIntl();

  return (
    <Stack spacing={2} useFlexGap>
      <Stack>
        <Typography variant="h5">
          {intl.formatMessage({
            id: 'containers.settings.queues.queue.automation.legacySettings.automationLevel.title',
          })}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {intl.formatMessage(
            {
              id: 'containers.settings.queues.queue.automation.legacySettings.automationLevel.description',
            },
            { boldText }
          )}
        </Typography>
      </Stack>

      <ToggleButtonGroup
        value={automationLevel}
        onChange={(_, value) => {
          if (value !== null) onChange(value);
        }}
        exclusive
        disabled={disabled}
      >
        {confidenceLevels.map(({ key }) => {
          return (
            <ToggleButton key={key} value={key}>
              {intl.formatMessage({
                id: `containers.settings.automation.documentAutomation.${key}.title`,
              })}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </Stack>
  );
};
